import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53389)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 12.2607H0V15.9004H49.9999V12.2607Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 19.54H0V23.1797H49.9999V19.54Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 26.8203H0V30.46H49.9999V26.8203Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 30.46H0V34.0996H49.9999V30.46Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 34.0996H0V37.7393H49.9999V34.0996Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.862108 41.3792H49.1379C49.614 41.3792 50 40.9932 50 40.5171V37.7393H0V40.5171C0 40.9933 0.386034 41.3792 0.862108 41.3792Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 12.2605V9.48271C49.9999 9.00664 49.6139 8.62061 49.1378 8.62061H0.862108C0.386034 8.6207 0 9.00664 0 9.48271V15.9004V19.5401V26.8199H49.9999V23.18H17.2414V19.5402H49.9999V15.9004H17.2414V12.2605H49.9999Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.2414 15.9003H10.4406V8.62061H6.80077V15.9003H0V19.5401H6.80077V26.8198H10.4406V19.5401H17.2414V15.9003Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53389",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGrFlag);
export { ForwardRef as ReactComponent };
